/**
 * Manuels AV — Shop (Stage 3 M2)
 * Mobile toolbar: browse drawer, filter drawer trigger, sort sync with Dawn facets.
 */
(function () {
  if (!document.body.classList.contains('template-collection')) return;

  const openBrowse = () => {
    const summary = document.getElementById('MavBrowseDrawerSummary');
    const details = summary?.parentElement;
    if (!summary || !details) return;
    if (!details.classList.contains('menu-opening')) summary.click();
  };

  const closeBrowse = () => {
    const details = document.getElementById('MavBrowseDrawerSummary')?.parentElement;
    if (details?.hasAttribute('open')) {
      details.querySelector('summary')?.click();
    }
  };

  document.querySelector('[data-mav-open-browse]')?.addEventListener('click', openBrowse);
  document.querySelector('[data-mav-close-browse]')?.addEventListener('click', closeBrowse);

  document.querySelector('[data-mav-open-filter]')?.addEventListener('click', () => {
    const summary = document.querySelector('.mobile-facets__wrapper summary');
    summary?.click();
  });

  const toolbarSort = document.querySelector('[data-mav-sort-select]');
  const syncToolbarSort = () => {
    const sortBy = document.getElementById('SortBy');
    const sortMobile = document.getElementById('SortBy-mobile');
    const value = toolbarSort?.value;
    if (!value || !toolbarSort) return;
    if (sortBy && sortBy.value !== value) {
      sortBy.value = value;
      sortBy.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (sortMobile && sortMobile.value !== value) {
      sortMobile.value = value;
    }
  };

  if (toolbarSort) {
    toolbarSort.addEventListener('change', syncToolbarSort);
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || target.name !== 'sort_by') return;
    if (toolbarSort && target.id !== 'MavSortByMobileToolbar') {
      toolbarSort.value = target.value;
    }
  });
})();
